import React from "react";
import { Loader2, Menu, MessageCircle, RefreshCw } from "lucide-react";
import { useAdminLayout } from "../AdminLayoutContext";

export default function AdminChatModerationChrome({
  loading,
  onRefresh,
  summary,
}) {
  const { openMobileMenu } = useAdminLayout();
  const total = summary?.total ?? 0;

  return (
    <>
      <header className="am-chrome ach-chrome">
        <div className="am-chrome-row ach-chrome-row">
          <div className="am-chrome-lead ach-chrome-lead">
            <button
              type="button"
              className="am-chrome-btn am-chrome-btn-icon lg:hidden"
              onClick={openMobileMenu}
              aria-label="Open menu"
              title="Menu"
            >
              <Menu size={16} strokeWidth={2.2} />
            </button>

            <div className="am-chrome-brand ach-chrome-brand" aria-label="BondChat moderation">
              <MessageCircle size={12} strokeWidth={2.3} aria-hidden />
              <span>BondChat</span>
            </div>

            <span className="ach-chrome-desk">Reported messages</span>

            <div className="am-chrome-stats ach-chrome-stats" aria-label="Report summary">
              <span className="am-chrome-stat ach-chrome-stat-open">
                <em>{total}</em> open
              </span>
            </div>
          </div>

          <div className="am-chrome-trail ach-chrome-trail">
            <button
              type="button"
              className="am-chrome-btn am-chrome-btn-icon"
              onClick={onRefresh}
              disabled={loading}
              aria-label="Refresh reports"
              title="Refresh"
            >
              {loading ? (
                <Loader2 size={15} className="am-spin" />
              ) : (
                <RefreshCw size={15} />
              )}
            </button>
          </div>
        </div>
      </header>
      <div className="am-chrome-spacer ach-chrome-spacer" aria-hidden />
    </>
  );
}
